// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"22cdf2f4","366":"1fa48431","985":"5d8891e0"}[chunkId] + ".chunk.css";
};